const BASE_URL = 'https://www.styror.com';

export const localBusinessSchema1 = {
  '@context': 'https://schema.org',
  '@type': 'LocalBusiness',
  name: 'StyroR – Styropor Recycling Hamburg',
  description: 'Professionelles Styropor Recycling, EPS Entsorgung und Isolierung Recycling in Hamburg.',
  url: BASE_URL,
  logo: `${BASE_URL}/logo.png`,
  telephone: '+49 1590 3782712',
  email: 'info@styror.com',
  address: {
    '@type': 'PostalAddress',
    streetAddress: 'Rennbahnstraße 2',
    addressLocality: 'Hamburg',
    postalCode: '22111',
    addressCountry: 'DE',
  },
  areaServed: {
    '@type': 'City',
    name: 'Hamburg',
  },
};

export const serviceSchema = {
  '@context': 'https://schema.org',
  '@type': 'Service',
  serviceType: 'Styropor Recycling & EPS Entsorgung',
  provider: {
    '@type': 'Organization',
    name: 'StyroR',
    url: BASE_URL,
  },
  areaServed: {
    '@type': 'City',
    name: 'Hamburg',
  },
  description: 'Professionelles Recycling und Entsorgung von EPS, Styropor, Airpop, Extrudiertem Polystyrol (XPS) und HBCD-belastetem Styropor.',
  hasOfferCatalog: {
    '@type': 'OfferCatalog',
    name: 'Recycling-Dienstleistungen',
    itemListElement: [
      { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'EPS / Styropor Recycling' } },
      { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'HBCD-belastetes Styropor entsorgen' } },
      { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Extrudiertes Polystyrol (XPS) entsorgen' } },
      { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Isolierung Recycling' } },
    ],
  },
};

export function generateBreadcrumbs(items: { name: string; url: string }[]) {
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.name,
      item: item.url,
    })),
  };
}
